
const calculatePageCount = (totalElements: number, pageSize: number) => {
  if (totalElements && totalElements > 0) {
    const nr = totalElements / pageSize;
    const rem = totalElements % pageSize;
    const fl = Math.floor(nr);
    const val = Math.round(nr);
    return val > fl ? val : // Already roundet up!
      rem > 0 ? val + 1 : val;
  }
  return 0;
};

const roundNumber = (value: number, decimals?: number, defaultValue?: string): string => {
  const dec:number = decimals && decimals > 0 ? decimals : 2;
  const ratio: number = dec * 10;
  const defVal:string = defaultValue && defaultValue?.length > 0 ? defaultValue : '0.00';
  if (!value) {
    return defVal;
  }

  return (Math.round(value * ratio) / ratio).toFixed(dec).toString();
};

const Utils = {
  calculatePageCount,
  roundNumber,
};

export default Utils;
